// extracted by mini-css-extract-plugin
export default {"termsSection":"termsSection_termsSection__TvskW","termsSection__title":"termsSection_termsSection__title__UR0jh"};